import { ChatHomeTilesApiError } from "./chat-home-tiles-api.js";

// Maps a failed CMS tiles request to user-facing Dutch messages. Server-provided
// `errors[]` (validation 400, concurrency 409, storage 503) are surfaced verbatim;
// otherwise the HTTP status is translated to a distinct, actionable message so an
// expired session, a storage outage, and a generic failure no longer look identical.
export function getChatHomeTilesErrorMessages(
  error: unknown,
  fallback: string,
): string[] {
  if (error instanceof ChatHomeTilesApiError) {
    if (error.errors.length) {
      return error.errors;
    }
    return [getStatusMessage(error.status, fallback)];
  }

  return [fallback];
}

export function getChatHomeTilesErrorMessage(
  error: unknown,
  fallback: string,
): string {
  return getChatHomeTilesErrorMessages(error, fallback)[0] ?? fallback;
}

export function isConcurrencyConflict(error: unknown): boolean {
  return error instanceof ChatHomeTilesApiError && error.status === 409;
}

function getStatusMessage(status: number, fallback: string): string {
  switch (status) {
    case 401:
    case 403:
      return "Je sessie is verlopen. Log opnieuw in om tegels te beheren.";
    case 409:
      return "Deze tegel is gewijzigd door een andere sessie. Laad de laatste versie en probeer het opnieuw.";
    case 503:
      return "De tegelopslag is tijdelijk niet beschikbaar. Probeer het later opnieuw.";
    default:
      return fallback;
  }
}
